import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLowSignal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#4784F5"
      d="M3.78 10.01a1.98 1.98 0 0 0-1.784 1.981L2 16.062c0 .703.423 1.339.974 1.657.639.37 1.378.376 2.018.014a1.94 1.94 0 0 0 1.004-1.7L5.988 11.9c-.003-1.17-1.073-2.017-2.208-1.89"
    />
    <path
      fill="#DDE3EA"
      d="M10.118 6c-1.115-.06-2.115.79-2.116 1.93l-.007 8.064a1.99 1.99 0 0 0 1.958 2.002c1.023.026 2.03-.776 2.032-1.884l.01-8.135a1.983 1.983 0 0 0-1.877-1.976M15.89 2.003a1.99 1.99 0 0 0-1.895 1.993v12.001c0 1.135.93 2.018 2.026 2.001 1.108-.017 1.984-.9 1.983-2.045l-.009-11.986c0-1.148-.984-2.027-2.105-1.964"
    />
  </svg>
);
export default SvgLowSignal;
